import React, { useState, useEffect, useContext } from "react";
import "../Review.css";
import {
  Grid,
  Box,
  Chip,
  TextField,
  Typography,
  MenuItem,
  Button,
  Divider,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Paper,
  Stack,
  Checkbox,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import CommentIcon from "@mui/icons-material/Comment";
import DialogContentText from "@mui/material/DialogContentText";
import { TextareaAutosize } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { CheckBox } from "@mui/icons-material";
import SearchIcon from "@mui/icons-material/Search";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { useSelector, useDispatch } from "react-redux";
import {
  ExportFile_ModifiedOrders,
  GetModifiedOrders,
  GetUserCountries,
  DeleteModifiedOrders,
  setState,
  reset,
} from "../reviewSlice";
//import Masonry from "@mui/lab/Masonry";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import MessageForReview from "../MessageForReview";
import muiConfig from "../../../assets/MuiConfig.json";

const ReviewButton = (params) => {
  return (
    <>
      <IconButton>
        <EditIcon />
      </IconButton>
    </>
  );
};

const DisplayComments = (params) => {
  const [displayComments, setDisplayComments] = useState("");
  const [userComments, setUserComments] = useState("");
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const handleConfirm = () => {
    setDisplayComments(userComments);
    setOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <IconButton onClick={() => setOpen(true)}>
        {displayComments ? <CommentIcon color="primary" /> : <CommentIcon />}
      </IconButton>

      <Dialog
        disableEnforceFocus
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">Comments</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <TextareaAutosize
              //onChange={(event) => setUserComments(event.target.value)}
              aria-label="minimum height"
              minRows={5}
              placeholder="Comments"
              style={{ width: 500, fontSize: 18 }}
              //defaultValue={displayComments}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button autoFocus variant="contained" onClick={handleConfirm}>
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const columns = [
  { field: "salesOrder", headerName: "Order Number", width: 150 },
  {
    field: "salesItemNo",
    headerName: "Sales Item Number",
    flex: 1,
  },
  {
    field: "geoCode",
    headerName: "Country",
    flex: 1,
  },
  {
    field: "customerNumber",
    headerName: "Customer Number",
    flex: 1,
  },
  {
    field: "customerName",
    headerName: "Customer",
    flex: 2,
  },
  {
    field: "skuNumber",
    headerName: "SKU Number",
    flex: 1,
  },
  {
    field: "skuName",
    headerName: "SKU Name",
    flex: 1,
  },
  {
    field: "intendedQtyPacks",
    headerName: "Intended Quantity",
    flex: 1,
    align: "center",
    headerAlign: "center",
    valueFormatter: (params) => {
      const formattedValue = Number(params.value)?.toLocaleString("en-US");
      return formattedValue;
    },
  },
  {
    field: "decisionCode",
    headerName: "Decision Code",
    flex: 1,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "stickToQuota",
    editable: false,
    headerName: "AT-STQ",
    flex: 1,
    minWidth: 100,
    align: "center",
    headerAlign: "center",
    renderCell: (cellValues) => {
      // debugger
      let checked = cellValues.row.stickToQuota;
      const label = { inputProps: { "aria-label": "Checkbox" } };
      if (checked === 1) {
        return <Checkbox {...label} defaultChecked disabled />;
      } else {
        return <Checkbox {...label} disabled />;
      }
    },
  },
];

const OrderDecision = () => {
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess === 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const dispatch = useDispatch();
  const review = useSelector((state) => state.review);
  const {
    isLoading,
    countries,
    selectedCountry,
    selectedCountryID,
    getModifiedOrders,
    deleteResponse,
    selectedPeriod,
  } = review;

  const loginState = useSelector((store) => store.login);
  const { globalSelectedCountryName, globalSelectedCountryID } = loginState;

  const [rows, setRows] = useState([]);
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 20,
    page: 0,
  });
  const [getSelectedRowsData, setSelectedRowsData] = React.useState([]);

  const handleCountryChange = (e) => {
    dispatch(setState("getModifiedOrders", []));
    const name = e.target.value;
    let countryID = null;
    // console.log(countries.find((country) => country.countryName === name));
    if (name === "All") {
      countryID = 0;
    } else {
      countryID = countries.find(
        (country) => country.countryName === name
      ).countryID;
    }

    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", countryID));
  };
  const handlePeriodChange = (e) => {
    dispatch(setState("getModifiedOrders", []));
    const period = e.target.value;
    dispatch(setState("selectedPeriod", period));
  };
  const handleExport = () => {
    if (
      selectedCountryID === null ||
      selectedCountryID === "" ||
      selectedCountry === ""
    ) {
      showMessage("Please select country", "info");
      return;
    }
    const obj = {
      countryID: selectedCountryID,
      countryName: selectedCountry,
    };
    dispatch(ExportFile_ModifiedOrders(obj));
  };

  const handleDelete = () => {
    dispatch(setState("isDeleteClicked", true));
    const obj = getSelectedRowsData?.map((item) => {
      return {
        customerId: item.customerId,
        customerName: item.customerName,
        customerNumber: item.customerNumber,
        decisionCode: item.decisionCode,
        intendedQtyPacks: item.intendedQtyPacks,
        modifiedQtyPacks: item.modifiedQtyPacks,
        salesItemNo: item.salesItemNo,
        salesOrder: item.salesOrder,
        selected: true,
        sentToSAP: item.sentToSAP,
        skuName: item.skuName,
        skuNumber: item.skuNumber,
        stickToQuota: item.stickToQuota,
      };
    });
    if (obj.length === 0) {
      showMessage("Please select rows to delete", "info");
      return;
    }

    dispatch(DeleteModifiedOrders(obj)).then(() => handleRetrive());
  };
  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };
  const handleRetrive = () => {
    dispatch(setState("getModifiedOrders", []));
    if (selectedCountryID === null || selectedCountryID === "") {
      showMessage("Please select country", "info");
      return;
    }
    if (selectedPeriod === null || selectedPeriod === "") {
      showMessage("Please select period", "info");
      return;
    }
    const obj = {
      countryID: selectedCountryID,
      period: selectedPeriod,
    };
    dispatch(GetModifiedOrders(obj));
  };

  // console.log(getModifiedOrders);

  useEffect(() => {
    if (rowSelectionModel?.length > 0) {
      setSelectedRowsData((prevVal) => {
        let selectedRows = rows.filter((row) => {
          return rowSelectionModel.includes(
            row.salesOrder + "_" + row.salesItemNo
          );
        });
        return selectedRows;
      });
    }
  }, [rowSelectionModel]);

  useEffect(() => {
    if (getModifiedOrders?.length > 0) {
      setRows(getModifiedOrders);
    } else {
      setRows([]);
    }
  }, [getModifiedOrders]);

  useEffect(() => {
    dispatch(reset("refresh OrderDecision"));
    if (countries.length <= 0) {
      dispatch(GetUserCountries({ method: "Get" }));
    }
  }, []);

  useEffect(() => {
    // debugger;
    if (
      globalSelectedCountryName !== null &&
      globalSelectedCountryName !== ""
    ) {
      dispatch(setState("selectedCountry", globalSelectedCountryName));
      dispatch(setState("selectedCountryID", globalSelectedCountryID));
      dispatch(setState("revGlobalCountryID", globalSelectedCountryID));
    }
  }, [globalSelectedCountryID]);

  useEffect(() => {
    setCountryOnPageLoad();
  }, []);

  const setCountryOnPageLoad = (countries) => {
    let canSetCountry =
      globalSelectedCountryID === null || globalSelectedCountryID === "";

    if (canSetCountry) {
      dispatch(setState("selectedCountry", "All"));
      dispatch(setState("selectedCountryID", 0));
    }
  };

  return (
    <div>
      <Box m={2}>
        {/* <Typography variant="subtitle2" my={2}>
                    Search for Scenario
                </Typography> */}
        {/* <form onSubmit={handleSubmit(onSubmit)}> */}
        {/* <Box className="scenario-search"> */}
        <Box>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={isLoading}
          >
            <CircularProgress />
          </Backdrop>
        </Box>
        <Box>
          <MessageForReview />
        </Box>
        <Grid
          container
          columns={12}
          justifyContent="flex-start"
          spacing={2}
          alignItems="center"
        >
          <Grid item xs={12} sm={6} md={2.5} lg={2.5}>
            <TextField
              variant="outlined"
              label="Country"
              select={countries.length > 0 ? true : false}
              //select={true}
              value={countries.length > 0 ? selectedCountry : ""}
              //value={""}
              onChange={handleCountryChange}
              fullWidth
              size="small"
              //disabled={countries.length > 0 ? false : true}
              // {...register("country", {
              //     required: "Please select a country",
              // })}
              // error={Boolean(errors.country)}
              // helperText={errors ?.country ?.message}
            >
              <MenuItem key={0} value={"All"}>
                {"All"}
              </MenuItem>
              {countries.length > 0
                ? countries.map((country, index) => {
                    return (
                      <MenuItem
                        key={country.countryID}
                        value={country.countryName}
                      >
                        {country.countryName}
                      </MenuItem>
                    );
                  })
                : null}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6} md={2.5} lg={2.5}>
            <TextField
              variant="outlined"
              label="Period"
              select={true}
              value={selectedPeriod ? selectedPeriod : ""}
              onChange={handlePeriodChange}
              size="small"
              fullWidth
            >
              <MenuItem value="1">Current</MenuItem>
              <MenuItem value="0">Previous</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={6} sm={2} md={2} lg={1}>
            <Box justifyContent="center" display="flex">
              <Button
                startIcon={<SearchIcon />}
                variant="contained"
                onClick={handleRetrive}
                size="large"
                sx={{
                  bgcolor: "darkred.light",
                  color: "white.main",
                  fontWeight: "700",
                  textTransform: "none",
                  "&:hover": {
                    bgcolor: "darkred.main",
                  },
                }}
              >
                Search
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      {rows?.length > 0 && (
        <Box sx={{ mt: 3 }}>
          <DataGridPro
            style={{ maxHeight: "calc(100vh - 130px)" }}
            rows={rows}
            columns={columns}
            getRowId={(row) => row?.salesOrder + "_" + row?.salesItemNo}
            sx={{ width: "100%" }}
            // paginationMode="client"
            // initialState={{
            //     pagination: { paginationModel: { pageSize:20, page:0 }}
            // }}
            //rowSelectionModel={rowSelectionModel}
            initialState={{
              pagination: { paginationModel: { pageSize: 20, page: 0 } },
            }}
            pagination
            pageSizeOptions={[
              20,
              50,
              100,
              { value: muiConfig.DataGrid_All, label: "All" },
            ]}
            checkboxSelection={true}
            disableRowSelectionOnClick
            disableColumnMenu
            onRowSelectionModelChange={(newRowSelectionModel) => {
              setRowSelectionModel(newRowSelectionModel);
            }}
            // rowHeight={30}
            // headerHeight={35}
          />
        </Box>
      )}
      {rows?.length > 0 && (
        <Box mt={3}>
          <Grid container columns={12} justifyContent="flex-end" spacing={1}>
            <Grid item xs={6} sm={2} md={2} lg={1.1}>
              <Box display="inline" sx={{ mt: 2 }}>
                <Button
                  //startIcon={<LockOpenRoundedIcon />}
                  sx={{
                    bgcolor: "darkred.light",
                    color: "white.main",
                    fontWeight: "700",
                    textTransform: "none",
                    "&:hover": {
                      bgcolor: "darkred.main",
                    },
                  }}
                  id="SearchButton"
                  disabled={!isRestrictedAccess}
                  onClick={handleDelete}
                >
                  Delete
                </Button>
              </Box>
            </Grid>

            {/* <Grid item xs={6} sm={2} md={2} lg={1}>
              <Box display="inline" sx={{ mt: 2 }}>
                <Button
                  //startIcon={<LockOpenRoundedIcon />}
                  sx={{ width: 120, height: 35, ml: -5 }}
                  style={{
                    background: "#007DC3",
                    color: "white",
                    borderRadius: "4px",
                    textTransform: "none",
                  }}
                  onClick={handleExport}
                  variant="outlined"
                  id="SearchButton"
                  disabled={!isRestrictedAccess}
                  // onClick={DisplayDiv}
                >
                  Export
                </Button>
              </Box>
            </Grid> */}
          </Grid>
        </Box>
      )}
    </div>
  );
};

export default OrderDecision;
